/** API case-request category: Extradition and Mutual Legal Assistance */
export const EXTRADITION_MLA_CATEGORY_CODE = 'EXTRADITION_MLA';
export const FILE_CATEGORY_EXTRADITION_MLA = 'Extradition and Mutual Legal Assistance';

/** Set when file categories load from API; used for id-based routing once known. */
export let EXTRADITION_MLA_CATEGORY_ID = '';

export function setExtraditionMlaCategoryId(id: string) {
  EXTRADITION_MLA_CATEGORY_ID = id.trim();
}

export function isExtraditionMlaCategory(item: {
  id?: string;
  name?: string;
  code?: string;
}): boolean {
  const code = (item.code ?? '').trim().toUpperCase();
  const name = (item.name ?? '').trim().toLowerCase();
  if (code === EXTRADITION_MLA_CATEGORY_CODE || code.includes('EXTRADITION')) return true;
  if (name.includes('extradition')) return true;
  if (name.includes('mutual') && name.includes('legal')) return true;
  return false;
}

export const EXTRADITION_MLA_WIZARD_STEPS = [
  { n: 1, lbl: 'Case Overview' },
  { n: 2, lbl: 'Accused Person Details' },
  { n: 3, lbl: 'Legal & Extradition' },
  { n: 4, lbl: 'Timeline' },
  { n: 5, lbl: 'Submission & Physical File Delivery' },
  { n: 6, lbl: 'Upload Documents' },
] as const;

export type ExtraditionMlaWizardStep = (typeof EXTRADITION_MLA_WIZARD_STEPS)[number]['n'];

/** CMS-MCC-1 — custody status options (fallback when API unavailable) */
export { CURRENT_CUSTODY_STATUSES as CUSTODY_STATUSES } from '../../../mocks/criminalMasterData';
